import React from 'react';
import { Col } from 'reactstrap';
import { isLpgProductId } from '../../../../shared/offer-domain/constants';
import useModelDeliveryTableBase from '../../hooks/modelDeliveryTable/useModelDeliveryTableBase';
import lpgStrategy from '../../hooks/modelDeliveryTable/strategies/lpg';
import nonLpgStrategy from '../../hooks/modelDeliveryTable/strategies/nonLpg';
import ModelDeliveryTableLpg from './lpg/ModelDeliveryTableLpg';
import ModelDeliveryTableNonLpg from './nonLpg/ModelDeliveryTableNonLpg';

const ModelDeliveryTable = props => {
  const isLpgProduct = isLpgProductId(props.form?.productNameId);
  const tableState = useModelDeliveryTableBase(
    props,
    isLpgProduct ? lpgStrategy : nonLpgStrategy
  );

  const content = isLpgProduct ? (
    <ModelDeliveryTableLpg {...props} {...tableState} />
  ) : (
    <ModelDeliveryTableNonLpg {...props} {...tableState} />
  );

  if (props.embedded) {
    return content;
  }

  return <Col sm={12}>{content}</Col>;
};

export default ModelDeliveryTable;
